import app from './app';

// italian
export default {
  app,
};
